import { useMemo } from "react";
import { Currency } from "@KassaroAB/shared/types/enums/currency";
import { useCatalogScope } from "../../../hooks/useCatalogScope";
import { useGetProductsQuery } from "../../../query/productsQuery";
import { useGetProductGroupsQuery } from "../../../query/productGroupsQuery";
import { useGetStoreQuery } from "../../../query/storesQuery";
import { useGetChainQuery } from "../../../query/chainsQuery";

export const useOfferFormCatalog = () => {
  const { scope, storeId, chainId } = useCatalogScope();
  const { data: store } = useGetStoreQuery(storeId ?? undefined);
  const { data: chain } = useGetChainQuery(chainId ?? undefined);
  const { data: products } = useGetProductsQuery(scope);
  const { data: groups } = useGetProductGroupsQuery(scope);

  const currency = store?.currency ?? chain?.currency ?? Currency.SEK;

  const productOptions = useMemo(
    () =>
      (products ?? []).map((product) => ({
        id: product.id,
        name: product.name,
        variants: product.variants ?? [],
        unitPrice: product.unitPrice,
        takeawayPrice: product.takeawayPrice ?? null,
        groupId: product.groupId,
      })),
    [products],
  );

  const groupOptions = useMemo(
    () => (groups ?? []).map((group) => ({ id: group.id, name: group.name })),
    [groups],
  );

  return {
    currency,
    products: products ?? [],
    productOptions,
    groupOptions,
  };
};
